export default {
    data() {
        return {
            cmsExtensionsBeforeSaveActionIsComplete: false,
        }
    },

    methods: {
        async getPageWithChildren(page) {
            const criteria = (new Shopware.Data.Criteria())
                .addAssociation('sections.blocks.slots.swagCmsExtensionsForm');

            return this.pageRepository.get(page.id, Shopware.Context.api, criteria);
        },

        async prepareCmsExtensionsDuplicateCmsPage(page, behavior = { overwrites: {} }) {
            const affectedCmsPage = page.cmsPage || page;

            const pageWithAssociations = await this.getPageWithChildren(affectedCmsPage);
            const sectionOverrides = pageWithAssociations.sections.reduce((accumulator, section, index) => {
                // The clone route compares the behavior with uuid-sorted database entries. Therefore, we must sort here as well.
                const sortedBlocks = [...section.blocks].sort((a, b) => a.id.localeCompare(b.id));
                const blockOverrides = sortedBlocks.reduce((sectionAccumulator, block, blockIndex) => {
                    block.slots.forEach((slot, slotIndex) => {
                        if (!slot.extensions?.swagCmsExtensionsForm) {
                            return;
                        }

                        const swagCmsExtensionsForm = slot.extensions.swagCmsExtensionsForm;
                        const technicalNameOverride = this.createCloneName(swagCmsExtensionsForm.technicalName);
                        const mailTemplateId = swagCmsExtensionsForm.mailTemplateId;

                        if (!sectionAccumulator[blockIndex]) {
                            sectionAccumulator[blockIndex] = { slots: {} };
                        }

                        sectionAccumulator[blockIndex].slots[slotIndex] = this.createCustomFormDuplicateOverride(technicalNameOverride, mailTemplateId);
                    });

                    return sectionAccumulator;
                }, {});

                if (Object.values(blockOverrides).length >= 1) {
                    accumulator[index] = {
                        blocks: blockOverrides,
                    };
                }

                return accumulator;
            }, {});

            if (Object.values(sectionOverrides).length <= 0) {
                this.cmsExtensionsBeforeSaveActionIsComplete = true;

                return this.onDuplicateCmsPage(page, behavior);
            }

            if (!behavior.overwrites) {
                behavior.overwrites = {};
            }

            behavior.cloneChildren = true;
            behavior.overwrites.sections = sectionOverrides;

            this.cmsExtensionsBeforeSaveActionIsComplete = true;

            return this.onDuplicateCmsPage(page, behavior);
        },

        onDuplicateCmsPage(item, behavior = { overwrites: {} }) {
            if (this.cmsExtensionsBeforeSaveActionIsComplete) {
                this.cmsExtensionsBeforeSaveActionIsComplete = false;
                this.$super('onDuplicateCmsPage', item, behavior);
            } else {
                void this.prepareCmsExtensionsDuplicateCmsPage(item, behavior);
            }
        },

        createCloneName(originalName) {
            return `${originalName}_${Shopware.Utils.createId()}`;
        },

        createCustomFormDuplicateOverride(technicalNameOverride, mailTemplateId) {
            return {
                extensions: {
                    swagCmsExtensionsForm: {
                        technicalName: technicalNameOverride,
                        mailTemplateId,
                    },
                },
            };
        },
    },
}
